import {DocumentAnalysis} from "./Document";
import {Account} from "./Account";
export class ExpenseAttachment {

  id!: string;
  name!: string;
  document_id?: string;
  content?: string;
  content_type?: string;
  size?: number;
  sha256?: string;
  content_url?: string;
  status?: string;
  error?: string;
  analysis?: DocumentAnalysis;
}

export class Expense {

  constructor() {
    this.date = new Date()
  }

  id!: string;
  name!: string;
  tenant!: string;
  date!: Date;
  account!: Account;
  account_id!: string;

  tax!: number;
  total!: number;
  attachments!: number;

  metadata!: { [key: string]: string };

  public GetCreatedDate(): Date {
    return new Date(this.date)
  }

  public GetDate(): Date {
    return new Date(this.date)
  }

  public CalcTotalContents(): number {
    return this.total;
  }

  public CalcTaxes(): number {
    return Number.isFinite(this.tax) ? this.tax : 0
  }

  public CalcGrandTotal(): number {
    return this.total
  }
}
